// Mirrors reviewableStatuses in the backend (pkg/notify/templates.go): the
// statuses in which the hotel has actually delivered the service, so a rating
// makes sense. Kept in one place because every request card needs it.
export const REVIEWABLE_STATUSES = ["Completed_Guest", "Completed_Hotel", "Closed_Hotel"];

export const isReviewable = (status) => REVIEWABLE_STATUSES.includes(status);
